import React, { useState } from 'react';

import Button from '../../library/button/button';
import Collapsible from '../../library/collapsible/collapsible';
import Typography from '../../library/typography/typography';
import CollapsibleToggle from '../../library/collapsible/components/collapsible-toggle/collapsible-toggle';
import BundleProductDescription from '../bundle-product-description/bundle-product-description';
import TireWheelPackageStatus from '../tire-wheel-package-status/tire-wheel-package-status';

import {
  useContainerQuery,
  useFitment,
  useNavigateTo,
  useTireWheelPackage
} from '../../shared/hooks/hooks';

import { getNormalizedProductType } from '../../shared/utils/product/product';

import { ENTRY_TYPES } from '../../shared/constants/cart';
import { PRODUCT_TYPES } from '../../shared/constants/products';

import styles from './tire-wheel-package-details.scss';

function TireWheelPackageDetails() {
  const navigateTo = useNavigateTo();
  const { isMinSm } = useContainerQuery();

  const {
    cancelIncompletePackage,
    currentTireWheelPackageFlow,
    incompletePackage,
    setCurrentTireWheelPackageFlow
  } = useTireWheelPackage();
  const [isOpen, setIsOpen] = useState(false);
  const { selectedFitment } = useFitment();

  if (!currentTireWheelPackageFlow) {
    return null;
  }

  async function onChangeProductInBundle() {
    await cancelIncompletePackage({ shouldExitPackageFlow: false });

    setCurrentTireWheelPackageFlow({
      step: 0,
      type: currentTireWheelPackageFlow?.type
    });

    navigateTo(
      `#/package/${
        getNormalizedProductType(incompletePackage?.product) ===
        PRODUCT_TYPES.WHEELS
          ? 'wheels'
          : 'tires'
      }`
    );
  }

  return (
    <div className={styles['container']}>
      {isMinSm && (
        <Typography tag="span" variant="H6" weight="black">
          Your Package
        </Typography>
      )}
      <div className={styles['status-container']}>
        <TireWheelPackageStatus
          onChangeProductInBundle={onChangeProductInBundle}
        />
        <CollapsibleToggle
          collapseType="SECONDARY"
          isOpen={isOpen}
          label="Package Details"
          toggleCollapsible={() => setIsOpen(!isOpen)}
        />
      </div>
      <Collapsible hideToggle isOpen={isOpen}>
        {incompletePackage?.product && (
          <>
            {selectedFitment?.isStaggered ? (
              <BundleProductDescription
                groupEntry={{
                  entries: [
                    {
                      basePrice: incompletePackage.basePrice,
                      markdownPriceData: incompletePackage.markdownPriceData,
                      product: incompletePackage.product,
                      quantity: incompletePackage.quantity,
                      totalQuantity: incompletePackage.totalQuantity
                    },
                    {
                      basePrice: incompletePackage.rearBasePrice,
                      markdownPriceData:
                        incompletePackage.rearMarkDownPriceData,
                      product: incompletePackage.rearProduct,
                      quantity: incompletePackage.rearQuantity,
                      totalQuantity: incompletePackage.totalQuantity
                    }
                  ],
                  entryType: ENTRY_TYPES.STAGGERED
                }}
                hideLabel
                hideProductType
                isReadOnly
                onChangeProductInBundle={onChangeProductInBundle}
              />
            ) : (
              <BundleProductDescription
                groupEntry={{ entries: [incompletePackage] }}
                hideLabel
                hideProductType
                onChangeProductInBundle={onChangeProductInBundle}
              />
            )}
          </>
        )}
        {!incompletePackage?.product && (
          <Typography
            className={styles['empty-package-message']}
            size="small"
            tag="span"
          >
            No items added to package yet.
          </Typography>
        )}
        <Button
          className={styles['cancel-btn']}
          onClick={() => navigateTo('/')}
          size="regular"
        >
          cancel package
        </Button>
      </Collapsible>
    </div>
  );
}

export default TireWheelPackageDetails;
